import React, { Component } from "react";
import { Row, Col, Modal, Form, Input, message, Spin, Select, Button } from 'antd';

import { AvatarLoader } from "../../Widgets/Uploaders";
import axios from "axios"
import { getResponseError } from "../../Utils";
import { useNavigate } from "react-router-dom";
import { SetUser } from "../../../Hooks/Logged";
import { SetCarrito } from "../../../Hooks/Carrito";
import { useCookies } from "react-cookie";
const { Option } = Select;



/**
 * @class ModalUsuarios
 * @description Modal para el CRUD de Usuarios
 */
class ModalUsuarios extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        if (this.props.usuario_id)
            this.get()

    }

    formRef = React.createRef();

    /**
    * @method addUser
    * @description Añade un nuevo registro de usuario
    */
    get = () => {
        this.setState({ loading: true })
        axios.get('/customer/usuarios/' + this.props.usuario_id)
            .then(({ data }) => {
                console.log("data", data);
                this.formRef.current.setFieldsValue({
                    ...data,
                    telefono: data.cliente_id?.telefono,
                    avatar: data.avatar ? {
                        uid: data.avatar.file,
                        name: data.avatar.name,
                        status: 'done',
                        fromDB: true,
                        url: axios.defaults.baseURL + "/customer/usuarios/" + data._id + "?avatar=" + data.avatar.file + "&Authorization=" + sessionStorage.getItem("token")
                    } : null
                })
                this.setState({ cliente: data.cliente_id })
            }).catch(error => {
                message.error('An error occurred while loading user information')
            }).finally(() => this.setState({ loading: false }))
    }


    /**
    * @method updateUser
    * @description Añade un nuevo registro de usuario
    */
    update = (values) => {

        console.log('update', values)
        this.setState({ loading: true })
        axios.put('/customer/usuarios', values, {
            headers: {
                "Content-Type": 'multipart/form-data'
            }
        })
            .then(response => {
                message.success('User updated successfully')
                this.props.onClose()
            }).catch(error => {
                console.log("error", error);
                message.error(getResponseError(error.response, 'An error occurred while updating the user'))
            }).finally(() => this.setState({ loading: false }))
    }

    /**
   * @method onFinish
   * @description Se ejecuta al hacer submit al formulario
   */
    onFinish = (values) => {

        const formData = new FormData()

        formData.appendMultiple({
            ...values,
            id: this.props.usuario_id,
        })

        if (this.props.usuario_id) {
            this.update(formData)
        }
    }

    handleDelete = () => {
        Modal.warning({
            title: 'Are you sure you want to delete your account?',
            content: 'This action is irreversible. All your data will be permanently deleted and cannot be recovered.',
            onOk: () => this.deleteAccount()
        });
    };
    
    deleteAccount = async () => {

        try{
            this.setState({loading: true})

            let data = await axios.delete('/customer')
    
            this.props.setUser(undefined);
            sessionStorage.clear();
            this.props.setCart({})
            this.props.navigate("/");
            this.props.setCookie('cart', null);
    
            if (window.FB) {
                window.FB.logout(function (response) {
                    console.log("response", response);
                });
            }
            
        }catch(error){
            console.log(error)
            message.error("Error")
        }

    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <Form
                    id="form-usuario"
                    layout={"vertical"}
                    onFinish={this.onFinish}
                    ref={this.formRef}
                >
                    <Row justify="center" className="center">
                        <Col span={20}>
                            <Row justify={"center"}>
                                <Form.Item
                                    name="avatar"
                                >
                                    <AvatarLoader
                                        imageCrop={true}
                                        onRemove={() => {
                                            axios.put('/usuarios/', {
                                                id: this.props.usuario_id,
                                                delete_avatar: true
                                            })
                                        }}

                                    />
                                </Form.Item>
                            </Row>
                            <Form.Item
                                name="nombre"
                                label="Name"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please, enter the name',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="apellidos"
                                label="Last Name"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please, enter the last name',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="email"
                                label="E-mail"
                                rules={[
                                    {
                                        type: 'email',
                                        message: 'Email is not valid',
                                    },
                                    {
                                        required: true,
                                        message: 'Enter the email',
                                    }, {
                                        max: 50,
                                        message: "Maximum 50 characters"
                                    },{
                                        validator: (_, value) => {
                                            // Transformar el valor a minúsculas
                                            const lowercaseValue = value.toLowerCase();
                                            if (value !== lowercaseValue) this.formRef.current.setFieldsValue({ email: lowercaseValue });
                                            return Promise.resolve();
                                        },
                                    }
                                ]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="telefono"
                                label="Phone Number"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please, enter the phone',
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>

                        </Col>
                    </Row>
                </Form>


                <Row>
                    <Col span={2}></Col>
                    <Col span={5}>
                        <Button danger onClick={this.handleDelete}>
                            Delete Account
                        </Button>
                    </Col>
                </Row>

            </Spin>
        )
    }


}



export default function Modals(props) {

    const { visible = false, onClose = () => { }, usuario_id } = props

    const navigate = useNavigate()
    const setUser = React.useContext(SetUser)
    const setCart = React.useContext(SetCarrito)
    const [ cookies, setCookie ] = useCookies(["cart"])

    return <Modal
        open={visible}
        onCancel={onClose}
        title={"Edit User Data"}
        closable={true}
        destroyOnClose={true}
        zIndex={1000}
        okButtonProps={{ form: 'form-usuario', key: 'submit', htmlType: 'submit' }}
    >
        <ModalUsuarios  {...props} navigate={navigate} setUser={setUser} setCart={setCart} setCookie={setCookie}/>
    </Modal>

}